export const receiveLoanSteps = [
  'اعتبارسنجی',
  'انتخاب وام',
  'تکمیل مدارک',
  'دریافت وام',
  'دریافت محصول',
];
